import { getAuthTokenValue } from "@kaihong/utils/lib/khAuthToken";

const _authTokenValue = getAuthTokenValue("X-Access-Token");

// 超级设备管理平台在cookie里的token设置到localStorage里。兼容未改造成KhAuthToken的业务系统。
if(_authTokenValue) {
  localStorage.setItem("X-Access-Token", _authTokenValue);
  console.log('在cookie里获取到超级设备管理平台的用户登录状态，并存入localStorage中。')
} else {
  console.warn('未在cookie里获取到超级设备管理平台的用户登录状态');
}